
import Divider from '@mui/material/Divider'

export const dividerWithText = (dividerWidth = 275, dividerColor = 'blue', dividerBorderColor = 'blue', marginTop = 0, marginBottom = 0) => {
  return (
    <Divider 
      sx={{
        mt: marginTop, mb: marginBottom,
        width: `${dividerWidth}px`,
        color: dividerColor,
        '&::before, &::after': {
          borderColor: dividerBorderColor,
        },
        display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
      }}
    >
      Or
    </Divider>
  )
}
